export default __webpack_public_path__ + "images/S6.8edd3bf.png";